import { Tooltip } from '@mui/material';
import { CSSProperties, FC } from 'react';

import { bannerStore } from '../../../studentApp/stores';
import { userStore } from '../../../studentApp/stores/userStore';
import { MAX_STUDENT_NAME_AND_CLASS_WIDTH } from '../../constants';

const nameClassStyle: CSSProperties = {
  color: 'white',
  maxWidth: `${MAX_STUDENT_NAME_AND_CLASS_WIDTH}`,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const NameAndClass: FC = () => {
  const studentName = userStore(state => state.studentName);
  const [currentClass, otherClasses] = bannerStore(state => [
    state.className,
    state.otherClasses,
  ]);
  const nameAndClass =
    studentName + (otherClasses.length > 0 ? ', ' + currentClass : '');

  return (
    <div style={nameClassStyle}>
      <Tooltip
        title={
          <>
            {'Student: ' + studentName}
            <br />
            {'Class: ' + currentClass}
          </>
        }
      >
        <span>{nameAndClass}</span>
      </Tooltip>
    </div>
  );
};
